<div>
    {{display.line1}} <br>
    {{display.line2}}
</div>
